import React, { useEffect, useState, useRef } from 'react'
import { StandaloneSearchBox, LoadScript } from "@react-google-maps/api";
import NavBar from "./NavBar"
import Footer from './Footer'
import "../../../styles/globalJobStyle.css"
import location from "../../../assets/locationhome.png"
import { FiSearch } from 'react-icons/fi'
import { MdLocationOn } from 'react-icons/md'
import { GoLocation } from "react-icons/go";
import { AiOutlineHeart } from "react-icons/ai";
import { useDispatch, useSelector } from 'react-redux'
import { getTotalJobs } from '../../../services/operations/JobPostAPI'
import Loader from "../../loader/Loader"
import JobCardSkeleton from './JobCardSkeleton'
import { useLocation, useNavigate } from 'react-router-dom'
import { useCallback } from 'react';
import { throttle } from 'lodash';

const GlobalJobs = () => {

  const [result, setResult] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 10,
    total_pages: 1,
    total: ""
  });

  const [visibleJobs, setVisibleJobs] = useState([]);
  const [filters, setFilters] = useState({
    postedDate: [],
    workSetting: [],
    employmentType: [],
    experience: [],
  })
  const [cityInput, setCityInput] = useState('');
  const [keyword, setKeyword] = useState('');
  const [loadData, setLoadData] = useState(false);
  const [isLoadMore, setIsLoadMore] = useState(false);
  const isMounted = useRef(true)
  const autocompleteRef = useRef(null);
  const autocompleteInstanceRef = useRef(null)
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate()
  const loading = useSelector((state => state.auth.loading))
  const baseUrl = window.location.origin
  const baseCandidateUrl = process.env.REACT_APP_CANDIDATE_URL;


  const libraries = ['places'];

  function LocationInput({ cityInput, setCityInput }) {
    const searchBoxRef = useRef(null);

    const handlePlacesChanged = () => {
      const places = searchBoxRef.current.getPlaces();
      if (places.length > 0) {
        setCityInput(places[0].formatted_address);
      }
    }
  }



  const fetchLocationDetails = async (lat, lng) => {
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    const res = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`
    );
    const data = await res.json();

    if (data.status === 'OK' && data.results[0]) {
      const components = data.results[0].address_components;

      const getComponent = (type) =>
        components.find((c) => c.types.includes(type))?.long_name;

      const city = getComponent('locality') || getComponent('administrative_area_level_2');
      const state = getComponent('administrative_area_level_1');
      const country = getComponent('country');
      const formattedLocation = '';
      //const formattedLocation = [city, state, country].filter(Boolean).join(', ');
      setCityInput(formattedLocation);
      return formattedLocation
    } else {
      console.error('Error fetching location:', data.status);
    }
  }

  const getRelativeDate = (createdAt) => {
    const createdDate = new Date(createdAt);
    const today = new Date();

    createdDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diffInMs = today - createdDate;
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInDays === 0) return "Today";
    if (diffInDays === 1) return "1 day ago";
    return `${diffInDays} days ago`;
  };

  const getPreciseRelativeTime = (updatedAt) => {
    const now = new Date();
    const updated = new Date(updatedAt);
    const diffInSeconds = Math.floor((now - updated) / 1000);

    if (diffInSeconds < 60) {
      return `${diffInSeconds} second${diffInSeconds !== 1 ? "s" : ""} ago`;
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} minute${diffInMinutes !== 1 ? "s" : ""} ago`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours !== 1 ? "s" : ""} ago`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays === 1) return "Yesterday";
    return `${diffInDays} days ago`;
  };

  useEffect(() => {
    isMounted.current = true
    const fetchGeoLocation = async () => {
      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject)
        })
        const { latitude, longitude } = position.coords
        const city = await fetchLocationDetails(latitude, longitude)
        if (isMounted.current) {
          setCityInput(city)
          handleSearch(1, false, { location: city })
        }
      } catch (error) {
        console.error('Error fetching location:', error)
        if (isMounted.current) handleSearch(1)
      }
    }
    fetchGeoLocation()
    return () => { isMounted.current = false }
  }, [])

  useEffect(() => {
    if (!window.google || !window.google.maps) return;
    if (!autocompleteInstanceRef.current && autocompleteRef.current) {
      autocompleteInstanceRef.current = new window.google.maps.places.Autocomplete(
        autocompleteRef.current,
        {
          types: ['geocode'],
          fields: ['address_components', 'formatted_address', 'place_id'],
        }
      );
      autocompleteInstanceRef.current.addListener("place_changed", () => {
        const place = autocompleteInstanceRef.current.getPlace();
        if (place && place.formatted_address) {
          setCityInput(place.formatted_address);
        }
      });
    }
  }, []);


  useEffect(() => {
    const interval = setInterval(() => {
      const pac = document.querySelector('.pac-container');
      if (pac && document.activeElement?.classList.contains('my-custom-autocomplete')) {
        pac.classList.add('my-pac-style');
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [cityInput]);


  const handleSearch = useCallback(throttle(async (page = 1, isLoadMore = false, payloadOverride) => {
    if (!isMounted.current) return
    setLoadData(true)
    try {
      const payload = payloadOverride || {
       // location: cityInput,
       location: "",
        keyword,
        posted_date: filters.postedDate,
        workplace_type: filters.workSetting,
        employment_type: filters.employmentType,
        experience: filters.experience
      }
      const resultData = await dispatch(getTotalJobs(payload, page))
      const newJobs = resultData?.data?.data
      if (newJobs) {
        setResult(prev => isLoadMore ? [...prev, ...newJobs.data] : newJobs.data)
        setPagination({
          current_page: newJobs.current_page,
          per_page: newJobs.per_page,
          total_pages: newJobs.last_page,
          total: newJobs.total
        })
      }
      else {
        setResult([]);
        setLoadData(false);
      }
    } catch (error) {
      console.error('Search error:', error)
    } finally {
      setLoadData(false)
    }
  }, 500), [cityInput, filters])

  useEffect(() => { handleSearch(1) }, [filters])
  // useEffect(() => { handleSearch(1) }, [keyword, cityInput])


  const handleViewMore = () => {
    if (pagination.current_page >= pagination.total_pages) return
    handleSearch(pagination.current_page + 1, true)
  }

  const onManualSearch = () => {
    handleSearch(1, false, {
      location: cityInput,
      keyword,
      posted_date: filters.postedDate,
      workplace_type: filters.workSetting,
      employment_type: filters.employmentType,
      experience: filters.experience
    });
  };

  const handleReset = () => {
    setKeyword('')
    setCityInput('')
    setFilters({
      postedDate: [],
      workSetting: [],
      employmentType: [],
      experience: [],
    })
    handleSearch(1, false, {
      location: '',
      keyword: '',
      posted_date: [],
      workplace_type: [],
      employment_type: [],
      experience: []
    })
  }

  const handleCheckboxChange = (e, category) => {
    const { value, checked } = e.target;

    setFilters((prevFilters) => {
      const currentCategoryValues = Array.isArray(prevFilters[category])
        ? prevFilters[category]
        : [];

      const updatedCategory = checked
        ? [...currentCategoryValues, value]
        : currentCategoryValues.filter((item) => item !== value);

      return {
        ...prevFilters,
        [category]: updatedCategory,
      };
    });
  };

  useEffect(() => {
    const applyCustomPacStyle = () => {
      const pac = document.querySelector('.pac-container');
      const activeEl = document.activeElement;
      if (pac && activeEl?.classList.contains('my-custom-autocomplete')) {
        pac.classList.add('my-pac-style');
      }
    };

    const observer = new MutationObserver(() => {
      applyCustomPacStyle();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    applyCustomPacStyle();

    return () => {
      observer.disconnect();
    };
  }, []);



  const handleApplyJob = (id) => {
    const applyUrl = `${baseCandidateUrl}?jobId=${id}`;
    window.open(applyUrl, "_blank");
  }



  return (
    <>
      {loading && <Loader />}
      <NavBar />
      <div className='all-jobs-dashboard'>
        <div className='all-jobs-container'>
          <div className='job-search-filter'>
            <div className="job-search-wrapper">
              <div className="job-input-field">
                <FiSearch className="job-search-icon" />
                <div className="vertical-line" />
                <input
                  type="text"
                  className="job-search-keyword"
                  placeholder="Job title or keyword"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                />
              </div>
              <p className="job-search-hint">Search skills</p>
            </div>
            <div className="job-search-wrapper" style={{ position: "relative" }}>
              <div className="job-input-field">
                <MdLocationOn className='job-search-icon' />
                <div className="vertical-line" />
                <input
                  ref={autocompleteRef}
                  className="job-search-keyword my-custom-autocomplete"
                  placeholder='Pennsylvania, USA'
                  onChange={(e) => setCityInput(e.target.value)}
                  autoComplete="off"
                />
              </div>
              <p className="job-search-hint">City, country</p>
            </div>
            <button className="job-search-button" disabled={loadData} onClick={onManualSearch}>Search Jobs</button>
          </div>
          {(keyword !== "" || cityInput !== "" || Object.values(filters).some(arr => arr.length > 0)) && (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button onClick={handleReset} className='job-list-clear-button'>Clear Filter</button>
            </div>
          )}

          <hr style={{ border: "2px solid rgba(173, 201, 254, 1)", margin: "20px 0px 40px 0px" }} />
          <div className='job-listing-section'>
            <div className='filter-checkbox-job'>
              <div className='checkbox-one-posted'>
                <label className='filter-checkbox-heading'>Posted Date</label>
                <div className='checkbox-options'>
                  <label>
                    <input type="checkbox" name="postedDate" value='any_date' checked={filters.postedDate.includes("any_date")} onChange={(e) => handleCheckboxChange(e, "postedDate")} />
                    Any date
                  </label>
                  <label>
                    <input type="checkbox" name="postedDate" value="today" checked={filters.postedDate.includes("today")} onChange={(e) => handleCheckboxChange(e, "postedDate")} />
                    Today
                  </label>
                  <label>
                    <input type="checkbox" name="postedDate" value="last_5_days" checked={filters.postedDate.includes("last_5_days")} onChange={(e) => handleCheckboxChange(e, "postedDate")} />
                    Last 5 days
                  </label>
                  <label>
                    <input type="checkbox" name="postedDate" value="more_than_10_days" checked={filters.postedDate.includes("more_than_10_days")} onChange={(e) => handleCheckboxChange(e, "postedDate")} />
                    More than 10 days
                  </label>
                </div>
              </div>
              <div className='checkbox-one-posted'>
                <label className='filter-checkbox-heading'>Work Settings</label>
                <div className='checkbox-options'>
                  <label>
                    <input type="checkbox" name="workSetting" value="remote" checked={filters.workSetting.includes("remote")} onChange={(e) => handleCheckboxChange(e, "workSetting")} />
                    Remote
                  </label>
                  <label>
                    <input type="checkbox" name="workSetting" value="onsite" checked={filters.workSetting.includes("onsite")} onChange={(e) => handleCheckboxChange(e, "workSetting")} />
                    On-Site
                  </label>
                  <label>
                    <input type="checkbox" name="workSetting" value="hybrid" checked={filters.workSetting.includes("hybrid")} onChange={(e) => handleCheckboxChange(e, "workSetting")} />
                    Hybrid
                  </label>
                </div>
              </div>
              <div className='checkbox-one-posted'>
                <label className='filter-checkbox-heading'>Employment Type</label>
                <div className='checkbox-options'>
                  <label>
                    <input type="checkbox" name="employmentType" value='full-time' checked={filters.employmentType.includes("full-time")} onChange={(e) => handleCheckboxChange(e, "employmentType")} />
                    Full-time
                  </label>
                  <label>
                    <input type="checkbox" name="employmentType" value='part-time' checked={filters.employmentType.includes("part-time")} onChange={(e) => handleCheckboxChange(e, "employmentType")} />
                    Part-time
                  </label>
                  <label>
                    <input type="checkbox" name="employmentType" value='contract' checked={filters.employmentType.includes("contract")} onChange={(e) => handleCheckboxChange(e, "employmentType")} />
                    Contract
                  </label>
                  <label>
                    <input type="checkbox" name="employmentType" value="temporary" checked={filters.employmentType.includes("temporary")} onChange={(e) => handleCheckboxChange(e, "employmentType")} />
                    Temporary
                  </label>
                </div>
              </div>
              <div className='checkbox-one-posted'>
                <label className='filter-checkbox-heading'>Experience type</label>
                <div className='checkbox-options'>
                  <label>
                    <input type="checkbox" name="experience" value='1-3' checked={filters.experience.includes("1-3")} onChange={(e) => handleCheckboxChange(e, "experience")} />
                    1-3
                  </label>
                  <label>
                    <input type="checkbox" name="experience" value='3-5' checked={filters.experience.includes("3-5")} onChange={(e) => handleCheckboxChange(e, "experience")} />
                    3-5
                  </label>
                  <label>
                    <input type="checkbox" name="experience" value='5-10' checked={filters.experience.includes("5-10")} onChange={(e) => handleCheckboxChange(e, "experience")} />
                    5-10
                  </label>
                  <label>
                    <input type="checkbox" name="experience" value='10+' checked={filters.experience.includes("10+")} onChange={(e) => handleCheckboxChange(e, "experience")} />
                    10+
                  </label>
                </div>
              </div>

            </div>
            <div className='job-listing-page'>
              {loadData ? (
                [...Array(3)].map((_, i) => <JobCardSkeleton key={i} />)
              ) : result?.length > 0 ? (
                result.map((job, index) => (
                  <div className='job-card-list' key={index}>
                    {/*<div className='job-card-left'>
                      <img className='job-logo' src={`https://api.dicebear.com/5.x/initials/svg?seed=${job?.company_name?.charAt(0)}`} />

                    </div>*/}
                    <div className='job-card-middle'>
                      <div className='job-listing-header'>
                        <div className='job-listing-title-exp'>
                          <h3 className='job-listing-title'
                            onClick={() => {
                              const encodedJob = encodeURIComponent(btoa(JSON.stringify(job.id)));
                              window.open(`${baseUrl}/job-detailing?job=${encodedJob}`);
                            }}>
                            {job?.job_title}</h3>
                          {job?.experience &&  job?.experience!=="N/A" && (
                            <p className="job-list-experience">
                              Exp - {(() => {
                                let parsed;

                                try {
                                  parsed =
                                    typeof job.experience === "string"
                                      ? JSON.parse(job.experience)
                                      : job.experience;         
                                } catch (e) {
                                  parsed = job.experience; 
                                }

                                let expDisplay = Array.isArray(parsed) ? parsed.join(", ") : parsed;

                                return `${expDisplay} Yrs`;
                              })()}
                            </p>
                          )}

                        </div>
                        <div className='job-listing-actions'>
                          <button className='job-listing-apply-button' onClick={() => handleApplyJob(job?.id)}>Apply now</button>
                        </div>
                      </div>
                      <div className='job-listing-title-exp'>
                        <a href="#" className='job-listing-company-name'>{job?.company_name}</a>
                        <div className='job-listing-location'>
                          <GoLocation className='job-listing-location-icon' />{job?.job_location}
                        </div>
                      </div>
                      <div className="job-listing-skills">
                        {job?.skills && (() => {
                          const parsedSkills = JSON.parse(job.skills);

                          return parsedSkills.length > 3 ? (
                            <>
                              {parsedSkills.slice(0, 3).map((skill, index) => (
                                <span key={index} className="skill-badge" style={{ margin: "4px 4px" }}>{skill}</span>
                              ))}
                              <span className="skill-badge" style={{ margin: "4px 4px" }}>+{parsedSkills.length - 3}</span>
                            </>
                          ) : (
                            parsedSkills.map((skill, index) => (
                              <span key={index} className="skill-badge" style={{ margin: "4px 4px" }}>{skill}</span>
                            ))
                          );
                        })()}
                      </div>
                      <hr className='job-listing-divider' />
                      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        <div className='job-listing-tags'>
                          {/* <span>{job?.employment_type} |</span>
                          <span>{job?.created_at ? getRelativeDate(job.created_at) : "N/A"} |</span>
                          <span>{job?.applied_count} applied |</span>
                          {job?.salary_range && <span>{job?.salary_range}</span>}
                          {job?.contract_price_per_hrs && <span>${job?.contract_price_per_hrs} /hr</span>} */}
                        </div>
                        <p className='job-listing-last-updated'>Last Updated {job?.updated_at ? getPreciseRelativeTime(job.updated_at) : "N/A"}</p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p style={{ padding: "2rem", textAlign: "center" }}>No jobs available at the moment.</p>
              )}
            </div>

          </div>
          {pagination.current_page < pagination.total_pages && (
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem" }}>
              <button onClick={handleViewMore} className="job-view-all-btn">
                View More
              </button>
            </div>

          )}
        </div>

      </div>
      <Footer />
    </>
  )
}

export default GlobalJobs